var _CorbadoAppState_corbadoApp, _CorbadoAppState_corbadoAppProps, _CorbadoAppState_sessionToken, _CorbadoAppState_isAuthenticated, _CorbadoAppState_user, _CorbadoAppState_globalError;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { CorbadoApp } from '@corbado/web-core';
export class CorbadoAppState {
    constructor(corbadoAppProps) {
        _CorbadoAppState_corbadoApp.set(this, void 0);
        _CorbadoAppState_corbadoAppProps.set(this, void 0);
        _CorbadoAppState_sessionToken.set(this, void 0);
        _CorbadoAppState_isAuthenticated.set(this, void 0);
        _CorbadoAppState_user.set(this, void 0);
        _CorbadoAppState_globalError.set(this, void 0);
        const corbadoApp = new CorbadoApp(corbadoAppProps);
        corbadoApp.sessionService.sessionTokenChanges.subscribe(value => {
            __classPrivateFieldSet(this, _CorbadoAppState_sessionToken, value, "f");
        });
        corbadoApp.sessionService.userChanges.subscribe(value => {
            __classPrivateFieldSet(this, _CorbadoAppState_user, value, "f");
        });
        corbadoApp.sessionService.authStateChanges.subscribe(value => {
            __classPrivateFieldSet(this, _CorbadoAppState_isAuthenticated, !!value, "f");
        });
        __classPrivateFieldSet(this, _CorbadoAppState_corbadoApp, corbadoApp, "f");
        __classPrivateFieldSet(this, _CorbadoAppState_corbadoAppProps, corbadoAppProps, "f");
    }
    async init() {
        const res = await __classPrivateFieldGet(this, _CorbadoAppState_corbadoApp, "f").init();
        if (res.err) {
            __classPrivateFieldSet(this, _CorbadoAppState_globalError, res.val, "f");
            return;
        }
        return;
    }
    get corbadoApp() {
        return __classPrivateFieldGet(this, _CorbadoAppState_corbadoApp, "f");
    }
    get corbadoAppProps() {
        return __classPrivateFieldGet(this, _CorbadoAppState_corbadoAppProps, "f");
    }
    get sessionToken() {
        return __classPrivateFieldGet(this, _CorbadoAppState_sessionToken, "f");
    }
    get sessionTokenChanges() {
        return __classPrivateFieldGet(this, _CorbadoAppState_corbadoApp, "f").sessionService.sessionTokenChanges;
    }
    get isAuthenticated() {
        return __classPrivateFieldGet(this, _CorbadoAppState_isAuthenticated, "f");
    }
    get authStateChanges() {
        return __classPrivateFieldGet(this, _CorbadoAppState_corbadoApp, "f").sessionService.authStateChanges;
    }
    get userChanges() {
        return __classPrivateFieldGet(this, _CorbadoAppState_corbadoApp, "f").sessionService.userChanges;
    }
    get user() {
        return __classPrivateFieldGet(this, _CorbadoAppState_user, "f");
    }
    get globalError() {
        return __classPrivateFieldGet(this, _CorbadoAppState_globalError, "f");
    }
    logout() {
        return this.corbadoApp.sessionService.logout();
    }
}
_CorbadoAppState_corbadoApp = new WeakMap(), _CorbadoAppState_corbadoAppProps = new WeakMap(), _CorbadoAppState_sessionToken = new WeakMap(), _CorbadoAppState_isAuthenticated = new WeakMap(), _CorbadoAppState_user = new WeakMap(), _CorbadoAppState_globalError = new WeakMap();
